export const MAIN_SOLUTION_PATH={
    'QUINDE' :'/quinde',
    'NUNA':'/nuna',
    'MIQO':'/miqo',
    'ALPAQQA':'/alpaqqa',
    'QREATIVEE':'/qreativee',
}